import { FormikProps, useField } from "formik";
import {
  useCoveragePriceCalculations,
  useFormState,
} from "Store/priceCalculation/priceCalculationHooks";

import { WrapLgMarginBottom } from "App/global-style";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import React from "react";
import { isDefined } from "Utils/functions";
import { AKA_TRAVEL_COVERAGE_FIELD_NAME } from "../akaTravelConstants";
import { AKA_TRAVEL_YOUR_PRODUCT_STEP } from "../akaTravelSteps";
import { AkaTravelProductIntroFormValues } from "../ProductIntro/akaTravelProductIntroInterfaces";
import { AkaTravelProductPriceFormValues } from "./akaTravelProductPriceInterfaces";
import { getCoverageToDisplay } from "./helpers";

interface Props {
  formProps: FormikProps<AkaTravelProductPriceFormValues>;
  isPriceLoading: boolean;
}

const { akatravel: productCardTextComponents } = getCollectionOfDittoComponents(
  TextComponentNameLevel1.COVERAGE_CARD,
);

export const AkaTravelCoverages = ({
  formProps,
  isPriceLoading,
}: Props): React.ReactElement => {
  const coverages = useCoveragePriceCalculations();
  const formProductIntro: AkaTravelProductIntroFormValues = useFormState(
    AKA_TRAVEL_YOUR_PRODUCT_STEP.id,
  );
  const coverageToDisplay = getCoverageToDisplay(formProductIntro);
  const selectedCoveragePriceCalculation = coverages.find(
    (coverage) => coverage[0] === coverageToDisplay,
  );
  const [coverageField] = useField(AKA_TRAVEL_COVERAGE_FIELD_NAME);
  coverageField.checked = true;

  return (
    <WrapLgMarginBottom>
      {!!selectedCoveragePriceCalculation && isDefined(coverages) && (
        <DittoCoverageCard
          key={`coverage-card_${coverageToDisplay}`}
          fieldName="AKA_TRAVEL_COVERAGE_FIELD_NAME"
          product={ProductBackendName.AKA_TRAVEL}
          coverage={coverageToDisplay}
          textComponents={productCardTextComponents}
          prices={selectedCoveragePriceCalculation[1].prices}
          priceIsLoading={isPriceLoading}
        />
      )}

      {isDefined(formProps.values.coverage) && (
        <CurrentPriceMessage
          productBackendName={ProductBackendName.AKA_TRAVEL}
          coverages={coverages}
          selectedPrices={[
            {
              selectedCoverage: formProps.values.coverage,
              selectedDeductible: undefined,
              defaultDeductible: undefined,
            },
          ]}
        />
      )}
    </WrapLgMarginBottom>
  );
};
